/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Pagination1OfDriverHaltAdminListedDto } from '../models/Pagination1OfDriverHaltAdminListedDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DriverHaltsService {
    /**
     * **Required Policy:** `ViewDriverHalts`
     * @returns Pagination1OfDriverHaltAdminListedDto OK
     * @throws ApiError
     */
    public static getDriverHaltsAdmin({
        driverId,
        isActive,
        startDate,
        endDate,
        regionId,
        page,
        limit,
    }: {
        driverId?: number,
        isActive?: boolean,
        startDate?: string,
        endDate?: string,
        regionId?: number,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfDriverHaltAdminListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driverhalts',
            query: {
                'driverId': driverId,
                'isActive': isActive,
                'startDate': startDate,
                'endDate': endDate,
                'regionId': regionId,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverHalts`
     * @returns any OK
     * @throws ApiError
     */
    public static postDriverHaltReleaseAdmin({
        driverId,
    }: {
        driverId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverhalts/{driverId}/release',
            path: {
                'driverId': driverId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverHalts`
     * @returns any OK
     * @throws ApiError
     */
    public static postDriverHaltAdmin({
        driverId,
    }: {
        driverId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverhalts/{driverId}',
            path: {
                'driverId': driverId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
